import { SignUpApprovalIllustration } from '../../../../assets/illustrations';
import MotionWrapper from '../../../../containers/MotionWrapper';
import { useDispatch } from '../../../../store/store';
import Button from '../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import {
    setIsLoggedIn,
    setAccessToProtectedRoutes,
} from '../../../../store/auth/slice';

interface Props {
    from?: string;
}

function Approval(props: Props) {
    const { from } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const navigateToDashboard = () => {
        dispatch(setAccessToProtectedRoutes(false));
        dispatch(setIsLoggedIn(true));
        navigate(from || '/workspace');
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <SignUpApprovalIllustration />
            <span className={styles.title}>Welcome</span>
            <span className={styles.text}>
                You have successfully signed up.
            </span>
            <Button
                type='Primary'
                className={styles.CTA}
                text='Go to dashboard'
                onClick={navigateToDashboard}
            />
        </MotionWrapper>
    )
};

export default Approval;
